module.exports = __webpack_public_path__ + "img/home.01ad9418.jpg";